<template>
  <m-dialog
    v-model:value="show"
    hide-footer
    :title="title"
  >
    <template v-if="dataSource !== null">
      <jira-editor
        v-if="dataSource.type === dataSourceType.jira"
        :entity="dataSource"
        @close="$emit('close')"
      />
      <data-source-editor
        v-else
        :entity="dataSource"
        @close="$emit('close')"
      />
    </template>
  </m-dialog>
</template>

<script setup>
import DataSourceEditor from '@/components/datasource/DataSourceEditor.vue';
import JiraEditor from '@/components/datasource/JiraEditor.vue';
import { camelCase } from 'lodash-es';
import { computed } from 'vue';
import { dataSourceType } from 'shared/constants.json';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  dataSource: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const show = computed({
  get: () => props.dataSource !== null,
  set: (value) => {
    if (!value) {
      emit('close');
    }
  },
});

const title = computed(() => {
  if (props.dataSource === null) {
    return '';
  }
  return t('dataSourceItem.editTitle', { source: t(`dataSources.${camelCase(props.dataSource.type)}`) });
});
</script>
